<template>
	<div class="map-bottom-bar">
		<div class="map-bottom-bar-header">
			<div class="map-bottom-bar-header-actions">
				<slot name="actions" />
			</div>
			<div class="map-bottom-bar-header-info">
				<slot name="info" />
			</div>
			<div class="map-bottom-bar-header-toggles">
				<slot name="toggles" />
			</div>
		</div>
		<div class="map-bottom-bar-content">
			<div class="map-bottom-bar-content-form">
				<slot name="form" />
			</div>
			<div class="map-bottom-bar-content-list">
				<slot :height="100" :width="190 + 10" name="list" />
			</div>
		</div>
	</div>
</template>

<script>
export default { name: 'MapBottomBar' };
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.map-bottom-bar {
	width: 100%;
	display: grid;
	grid-template-rows: 40px auto;
	background-color: get-color($background, 'tint2');
	max-height: 190px;
	overflow: hidden;
}

.map-bottom-bar-header {
	--light-blue-gray: #c7ced4
}

.map-bottom-bar-header {
	grid-row:1;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	width: auto;
	min-width: 100%;
	box-shadow: inset 0 -1px 0 0 var(--light-blue-grey);
	background: white;
	height: 40px;
	padding: 0px 15px;
	align-items: center;
	overflow-y: hidden;
	overflow-x: visible;
	flex: auto;
}

.map-bottom-bar-header-actions {
	flex: 0.2;
	display: flex;
	align-items: center;
	flex-direction: row;
	height: 100%;
	min-width: 200px;
}

.map-bottom-bar-header-info {
	flex: 1;
	min-width: 500px;
}

.map-bottom-bar-header-toggles {
	margin-right: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	min-width: 200px;
}

.map-bottom-bar-content {
	box-sizing: border-box;
	grid-row: 2;
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: minmax(min-content, max-content) auto;
}

.map-bottom-bar-content-form {
	box-sizing: border-box;
	padding: 10px;
	min-width: 230px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
}
.map-bottom-bar-content-list {
	box-sizing: border-box;
	position: relative;
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	display: flex;
	flex-direction: row;
	padding-top: 5px;
	padding-right: 10px;
}
.map-bottom-bar-content-list::after {
	padding-left: 5px;
	height: 100%;
	content: '';
}

.map-bottom-bar-content-list > * {
	flex-shrink: 0;
}
</style>
